<template>
  <v-snackbar
    v-model="showSnackBar"
    color="info"
    top
  >
    <span v-html="message"></span>
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        color="white"
        v-bind="attrs"
        @click="showSnackBar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  data () {
    return {
      showSnackBar: false,
      message: null
    }
  },
  methods: {
    open (message) {
      this.showSnackBar = true
      this.message = message
    }
  }
}
</script>
